/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AccessibilityManager } from 'pixi.js-legacy';

/**
 * PIXI's AccessibilityManager only updates divs after a render. Since we want to be able to properly visualize changes when
 * pressing tab (activating), we force a render to happen. Unfortunately, we can only do this by injecting some code into
 * the activate function.
 */
export function decorateAccessibilityManager(safeRender: () => void) {
	// Decorate activate function
	const activate = (<any>AccessibilityManager.prototype).activate;
	(<any>AccessibilityManager.prototype).activate = function () {
		activate.call(this);
		safeRender();
	};
}
